#import "../fragments/sms-edition-fragment.graphql"

mutation UnscheduleSmsEdition($input: EditionUnscheduleInput!) {
    editionUnschedule(input: $input) {
        edition {
            ...SmsEditionFragment
        }
    }
}
